import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getUnits } from '../../api/dashboard';
import PageHeader from '../../components/PageHeader';
import StatusMessage from '../../components/StatusMessage';
import { adminErrorMessage } from './adminErrors';
import './Admin.css';

const plural = (n, word) => `${n ?? 0} ${word}${n === 1 ? '' : 's'}`;

const sortUnits = (units) =>
  [...units].sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true }));

// Units and their rosters come from the organization's database and are
// managed by Kabilah, so this page is read-only.
const Units = () => {
  const navigate = useNavigate();
  const [units, setUnits] = useState(null);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setError(null);
    try {
      setUnits(sortUnits((await getUnits()).units || []));
    } catch (err) {
      setError(adminErrorMessage(err, "We couldn't load the units."));
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <>
      <PageHeader title="Units" after={units && <span className="count-pill">{units.length}</span>} />
      <div className="component-container">
        <div className="admin-content">
          {error && <StatusMessage kind="error" onRetry={load}>{error}</StatusMessage>}
          {!error && !units && <StatusMessage kind="loading">Loading units…</StatusMessage>}
          {units && (
            <div className="card-list">
              {units.length === 0 && <p className="admin-hint">Your organization doesn't have any units yet.</p>}
              {units.map((unit) => (
                <div key={unit.id} className="list-card">
                  <div className="list-card-main">
                    <span className="list-card-name">{unit.name}</span>
                    <div className="list-card-meta">
                      <span>{plural(unit.nurseCount, 'nurse')}</span>
                      <span className="list-card-meta-divider">·</span>
                      <span>{plural(unit.roomCount, 'room')}</span>
                    </div>
                  </div>
                  <div className="list-card-actions">
                    <button type="button" className="title-button" onClick={() => navigate(`/units/${encodeURIComponent(unit.id)}`)}>
                      View
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Units;
